var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"app-input-text",style:({
    height: (_vm.height + "px")
  }),attrs:{"type":"text"},domProps:{"value":_vm.text},on:{"input":_vm.inputed}})}
var staticRenderFns = []

export { render, staticRenderFns }